import { render, staticRenderFns } from "./MA11.vue?vue&type=template&id=2ec9dbf3&scoped=true&"
import script from "./MA11.vue?vue&type=script&lang=js&"
export * from "./MA11.vue?vue&type=script&lang=js&"
import style0 from "./MA11.vue?vue&type=style&index=0&id=2ec9dbf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9dbf3",
  null
  
)

export default component.exports